(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[890],{

/***/ 2871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(6861);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./constants/policies.tsx
var policies = __webpack_require__(337);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/terms-sections/content.tsx



var TermsSectionContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-y-8 md:max-w-[720px]",
        children: policies/* termsOfUsePolicies.map */.q.map(function(content) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "h5 text-text-color-high-em",
                        children: content.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-body-md text-text-color-mid-em",
                        children: content.body.split("<br/>").map(function(bodyContent) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    bodyContent,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }, bodyContent);
                        })
                    })
                ]
            }, content.title);
        })
    });
};
/* harmony default export */ var content = (TermsSectionContent);

// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
;// CONCATENATED MODULE: ./components/terms-sections/header.tsx



var TermsSectionHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center gap-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                overrideClassName: "text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mobile-h3 xs:h4 md:h3",
                    children: "Website Terms and Conditions of Use"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-2 w-36"
                })
            })
        ]
    });
};
/* harmony default export */ var header = (TermsSectionHeader);

;// CONCATENATED MODULE: ./pages/terms.tsx



var TermsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "m-6 md:m-20 flex flex-col gap-y-10 md:gap-y-20 items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(content, {})
        ]
    });
};
/* harmony default export */ var terms = (TermsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [643,774,888,179], function() { return __webpack_exec__(2871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);